export default {
    getItems: state => {
        return state.items;
    },
    getById: state => id => {
        return state.items.find(i => i.id === id);
    },
}